import { css } from "@emotion/react";


export const emotionGlobalCss = css`

.facebookWidget{
  width: 299px;
  position: relative;
}
.facebookSquareIcon1 svg {
  position: absolute;
  top: -3px;
  right: 229px;
  z-index: 2;
  width: 75.5px !important;
  height: auto !important;
  padding: 0 0px;
  background-color: transparent;
  color: #4267b2;
}
.fbIconBackground{
  position: absolute;
  top: 5px;
  right: 235px;
  background-color: white;
  width: 60px;
  height: 60px;
  z-index: 1;
}
 
.facebookSquareIcon svg{
  position: absolute;
  top: -1.5px;
  right:229px;
  z-index: 2;
  width: 71.5px !important;
  height:auto !important;
  padding: 0 3px;
  background-color: white;
  color: #4267b2;
}
.facebookSquareIcon svg:hover{
color: #365899;
}

#facebook button{
  background-color: black !important;
}
@media (max-width:767px) {
  .widgetContainer{
    margin-bottom:34px;
  }
  }
}

`  